module.exports = __webpack_public_path__ + "img/git-pull-request.b4504443.svg";